module.exports = __webpack_public_path__ + "img/icon-info.8aa49a0d.svg";